import { today as ariaToday } from '@internationalized/date';

import guessUserTimeZone from './guessUserTimeZone';

const today = () => {
    const timeZone = guessUserTimeZone();
    return ariaToday(timeZone);
};

export default today;
